// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin panel – simple, sober theme */
:root {
  --sidebar-bg: #ffffff;
  --sidebar-text: #334155;
  --sidebar-text-muted: #64748b;
  --sidebar-active: #f1f5f9;
  --sidebar-border: #e2e8f0;
  --sidebar-width: 260px;
  --header-bg: #ffffff;
  --header-shadow: 0 1px 3px rgba(0,0,0,0.06);
  --main-bg: #f1f5f9;
  --card-bg: #ffffff;
  --card-shadow: 0 1px 3px rgba(0,0,0,0.06);
  --border: #e2e8f0;
  --text: #334155;
  --text-muted: #64748b;
  --primary: #0f766e;
  --radius: 10px;
  --radius-sm: 8px;
  --font: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: var(--font);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--main-bg);
  color: var(--text);
}

a {
  color: inherit;
  text-decoration: none;
}

button {
  font-family: inherit;
  cursor: pointer;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,qBAAqB;EACrB,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kFAAkF;AACpF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,mCAAmC;EACnC,kCAAkC;EAClC,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB","sourcesContent":["/* Admin panel – simple, sober theme */\n:root {\n  --sidebar-bg: #ffffff;\n  --sidebar-text: #334155;\n  --sidebar-text-muted: #64748b;\n  --sidebar-active: #f1f5f9;\n  --sidebar-border: #e2e8f0;\n  --sidebar-width: 260px;\n  --header-bg: #ffffff;\n  --header-shadow: 0 1px 3px rgba(0,0,0,0.06);\n  --main-bg: #f1f5f9;\n  --card-bg: #ffffff;\n  --card-shadow: 0 1px 3px rgba(0,0,0,0.06);\n  --border: #e2e8f0;\n  --text: #334155;\n  --text-muted: #64748b;\n  --primary: #0f766e;\n  --radius: 10px;\n  --radius-sm: 8px;\n  --font: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--font);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: var(--main-bg);\n  color: var(--text);\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\nbutton {\n  font-family: inherit;\n  cursor: pointer;\n}\n\nul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
